/**
 * MIRAK shop the look: click a hotspot dot to reveal its product card.
 * Only one card is open at a time; clicking elsewhere or pressing Escape
 * closes whatever is open.
 */

function initHotspots(section) {
  const hotspots = Array.from(section.querySelectorAll('[data-mirak-hotspot]'));
  if (!hotspots.length) return;

  const closeAll = (except) => {
    hotspots.forEach((hotspot) => {
      if (hotspot === except) return;
      hotspot.classList.remove('is-open');
      hotspot.querySelector('[data-mirak-hotspot-dot]')?.setAttribute('aria-expanded', 'false');
    });
  };

  hotspots.forEach((hotspot) => {
    const dot = hotspot.querySelector('[data-mirak-hotspot-dot]');
    if (!dot) return;

    dot.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = hotspot.classList.contains('is-open');
      closeAll(hotspot);
      hotspot.classList.toggle('is-open', !isOpen);
      dot.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.addEventListener('click', () => closeAll(null));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll(null);
  });
}

document.querySelectorAll('[data-mirak-shop-the-look-section]').forEach(initHotspots);
